import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssetFileDTO, SharedAssetFullDTO } from '../../../../services/api/api';
import { UtilService } from '../../../../services/util.service';

@Component({
  selector: 'sb-page-shared-asset',
  templateUrl: './shared-asset.component.html',
  styleUrls: ['./shared-asset.component.scss'],
  standalone: false,
})
export class SharedAssetComponent implements OnInit {
  @Input() sharedAsset: SharedAssetFullDTO;

  @Output() convertToMediumClick: EventEmitter<AssetFileDTO>;
  @Output() convertAllToMediaClick: EventEmitter<SharedAssetFullDTO>;

  constructor(public util: UtilService) {
    this.convertToMediumClick = new EventEmitter<AssetFileDTO>();
    this.convertAllToMediaClick = new EventEmitter<SharedAssetFullDTO>();
  }

  ngOnInit(): void {}
}
